import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NVD3Chart from 'react-nvd3';
import * as d3 from 'd3';

import hideNVD3Tooltip from '../../utils/hideNVD3Tooltip';


const getAccountIndex = (res, key) => {
    for (let i = 0; i < res.length; i += 1) {
        if (res[i].key === key) {
            return i;
        }
    }
    return -1;
};

const pushAccountData = (res, key, value, time) => {
    const index = getAccountIndex(res, key);
    // Account is not yet in the res array
    if (index === -1) {
        const newResItem = {
            key,
            values: [
              [time, value],
            ],
        };
        res.push(newResItem);
        return res;
    }
    // Account is already in res
    res[index].values
    .push([time, value]);
    return res;
};

const trimNullData = data => {
    const res = [];
    for (let i = 0; i < data.length; i += 1) {
        const elementValues = data[i].values;
        let valuesTotal = 0;
        for (let j = 0; j < elementValues.length; j += 1) {
            valuesTotal += elementValues[j][1];
        }
        if (valuesTotal > 0) {
            res.push(data[i]);
        }
    }
    return res;
};

const formatDataForChart = data => {
    let res = [];

    for (let i = 0; i < data.length; i += 1) {
        const timeRangeElement = data[i];
        for (const key in timeRangeElement.operations) {
            if (timeRangeElement.operations.hasOwnProperty(key)) {
                res = pushAccountData(
                  res,
                  key,
                  timeRangeElement.operations[key],
                  timeRangeElement.timeRange
                );
            }
        }
    }
    return trimNullData(res);
};

const context = {
    formatXAxis: d => (d3.time.format('%m/%d %H:%M')(new Date(d))),
    formatYAxis: d => d,
};


class OperationsHistoryChartComponent extends Component {
    componentWillReceiveProps() {
        hideNVD3Tooltip();
    }

    render() {
        return (
          <div>
            <NVD3Chart
              id="barChart"
              type={this.props.horizontal
                ? 'multiBarHorizontalChart' : 'multiBarChart'}
              datum={formatDataForChart(this.props.data)}
              context={context}
              xAxis={{
                  tickFormat: {
                      name: 'formatXAxis',
                      type: 'function',
                  },
              }}
              yAxis={{
                  tickFormat: {
                      name: 'formatYAxis',
                      type: 'function',
                  },
              }}
              margin={this.props.horizontal
                ? { left: 100 } : { right: 50 }}
              rightAlignYAxis={true}
              clipEdge={false}
              showControls={true}
              showLegend={true}
              stacked={true}
              x={ d => {
                  const date = new Date(d[0]);
                  return date.getTime();
              }}
              y={ d => (d[1])}
              height={this.props.height || (this.props.horizontal ? 850 : 400)}
            />
          </div>
        );
    }
}

OperationsHistoryChartComponent.propTypes = {
    horizontal: PropTypes.bool,
    height: PropTypes.number,
    data: PropTypes.array.isRequired,
};

export default OperationsHistoryChartComponent;



/** WEBPACK FOOTER **
 ** ./src/components/charts/OperationsHistoryChartComponent.js
 **/